module.exports = __webpack_public_path__ + "static/google_playstore-94068b2ae674605e6087bbbbe4aff36f.svg";